import apiResponse from '@stores/ApiResponse';
import { QuestionnaireAssignment, QuestionnaireAssignmentStore } from '@stores/QuestionnaireAssignmentStore';
import actionResponse, { ActionResponse } from '@actions/ActionResponse';

/** Saves which questionnaires a cohort asks, and on which schedule, after the cohort itself is saved. */
export class SyncCohortQuestionnairesAction {
  constructor(private readonly store: QuestionnaireAssignmentStore = new QuestionnaireAssignmentStore()) {}

  public async Execute(cohortId: number, assignments: QuestionnaireAssignment[]): Promise<ActionResponse> {
    try {
      await apiResponse.handleApiResponse(() => this.store.SyncCohortAssignments(cohortId, assignments));
      return actionResponse.Success('saved questionnaire assignments');
    } catch (err) {
      return actionResponse.HandleError(err);
    }
  }
}
